var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIconMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25001 15C8.25001 14.5858 8.58579 14.25 9.00001 14.25H15C15.1381 14.25 15.25 14.1381 15.25 14L15.25 2C15.25 1.86193 15.1381 1.75 15 1.75L9 1.75C8.58579 1.75 8.25001 1.41421 8.25001 1C8.25001 0.585788 8.58579 0.25 9 0.25H15C15.9665 0.25 16.75 1.0335 16.75 2V14C16.75 14.9665 15.9665 15.75 15 15.75H9.00001C8.58579 15.75 8.25001 15.4142 8.25001 15Z",
    fill: "#FF1010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6116 9.11522C12.6116 9.6675 12.1639 10.1152 11.6116 10.1152H6.75562C6.73269 10.4706 6.70399 10.8258 6.66951 11.1805L6.63985 11.4857C6.59162 11.982 6.06466 12.2791 5.61504 12.0637C3.78712 11.1876 2.13234 9.98887 0.730282 8.525L0.700325 8.49372C0.433225 8.21485 0.433225 7.77506 0.700325 7.49619L0.730283 7.46491C2.13234 6.00104 3.78712 4.80226 5.61504 3.92625C6.06466 3.71077 6.59162 4.00796 6.63985 4.5042L6.66951 4.8094C6.70399 5.16413 6.73269 5.51928 6.75562 5.8747L11.6116 5.87471C12.1639 5.87471 12.6116 6.32242 12.6116 6.8747V9.11522Z",
    fill: "#FF1010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconMobile);
export default __webpack_public_path__ + "static/media/logoutIconMobile.3a8b8c481a6a5fcc0bd4db146e889cf2.svg";
export { ForwardRef as ReactComponent };